import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/pages/layoutChrome";
import { ModuleFeatureCard } from "@/components/HubModuleCard";
import ModulePlanBlockedDialog from "@/components/ModulePlanBlockedDialog";
import ModuleClientSelector from "@/components/ModuleClientSelector";
import { WORK_MODULES } from "@/modules/workModuleCore";
import { resolveModuleNavIcon } from "@/modules/moduleNavIcons";
import { useModuleAccess } from "@/modules/useModuleAccess";
import {
  TRAMITES_CONTEXT_LABEL,
  getTramitesFeatureCards,
} from "@/modules/tramites/manifest";
import { buildTramitesUrl } from "@/modules/tramites/tramitesService";
import { LayoutDashboard } from "lucide-react";
import DespachoOperationalSummary from "@/components/despacho/DespachoOperationalSummary";

/**
 * Hub del módulo Trámites Fiscales — tarjetas por función (sin capa intermedia ni tabs).
 */
export default function TramitesHubPage() {
  const navigate = useNavigate();
  const cards = useMemo(
    () => getTramitesFeatureCards(buildTramitesUrl),
    [],
  );

  const {
    hasModuleAccess,
    accessLoading,
    guardCriticalAction,
    planBlockedOpen,
    setPlanBlockedOpen,
  } = useModuleAccess(WORK_MODULES.TRAMITES_FISCALES);

  const openFeature = (path) => {
    guardCriticalAction(() => navigate(path));
  };

  return (
    <>
      <PageHeader
        title={TRAMITES_CONTEXT_LABEL}
        subtitle="Elija un trámite o consulta. Validación RFC, inscripciones SAT/IMSS, NSS y descargas institucionales."
        breadcrumb={[TRAMITES_CONTEXT_LABEL]}
      />

      <div className="px-8 pt-4 w-full max-w-none">
        <ModuleClientSelector variant="panel" className="mb-6" />
      </div>

      <div className="p-8 pt-0 w-full max-w-none" data-testid="tramites-hub-page">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
          {cards.map((card) => {
            const Icon = resolveModuleNavIcon(card.iconKey, LayoutDashboard);
            return (
              <ModuleFeatureCard
                key={card.path}
                label={card.label}
                description={card.description}
                icon={Icon}
                hasModuleAccess={hasModuleAccess}
                accessLoading={accessLoading}
                testId={card.testid}
                onEnter={() => openFeature(card.path)}
              />
            );
          })}
        </div>

        <div className="mt-8">
          <DespachoOperationalSummary />
        </div>
      </div>

      <ModulePlanBlockedDialog open={planBlockedOpen} onOpenChange={setPlanBlockedOpen} />
    </>
  );
}
